/**
 * How a market names itself on screen.
 *
 * There were three copies of this before there was a module: `BetLedger` parsed `map(\d+)` with a
 * regex, `SeasonBoard` took `market.slice(3)`, and the activity feed was about to be a fourth. They
 * agreed on every value the API actually sends, which is exactly why the drift would have been
 * invisible — `slice(3)` answers "ap10" for a hypothetical `map10` and simply returns the raw string
 * for anything unrecognised, and nobody would have found that from the screen.
 *
 * One vocabulary, for the reason `Data/TeamNames.cs` is one vocabulary on the server.
 */

/** "map3" reads as "Map 3"; the series market keeps its own name. */
export function marketLabel(market: string): string {
  if (market === 'series') return 'Series'
  const map = /^map(\d+)$/.exec(market)
  return map ? `Map ${map[1]}` : market
}
